<template>
    <v-container style="padding-top: 80px !important" class="pt-5">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4 cardConcluidos">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Detalle</p>
                <v-spacer></v-spacer>
                <template v-if="showReportes">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-on="on" v-bind="attrs" icon fab dark @click="DescargarExcel()"
                                :disabled="disabledExcel">
                                <v-icon dark style="cursor: pointer !important" class="hover">
                                    mdi-file-excel-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
                </template>
            </v-card-title>
            <v-card-text v-if="showReportes">
                <v-row class="mt-1">
                    <v-col cols="12" md="6" sm="6">
                        <v-btn @click="Regresar()" color="success">
                            Regresar
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="showReportes">
                    <v-col cols="12">
                        <DataTable :url="urlReportes" :columns="columnasReporte" :params="displayInputsReportes"
                            :order="[]" :formatterActions="formatterActionsReportes" @apiDT="apiDT = $event"
                            @cargando="valCargando">
                        </DataTable>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text v-else class="mt-2">
                <v-row justify="center">
                    <div v-for="(item, index) in concluidos" :key="index" class="mt-1">
                        <v-card elevation="2" outlined class="my-2 mx-2" min-width="300" min-height="150"
                            style="border-left: 0.25rem solid #4e73df !important; cursor: pointer;"
                            @click="BuscarPendientes(item)" :disabled="item.Conteo == 0 ? true : false">
                            <!-- <v-card-title class="text-h5">{{ item.nombremes }}</v-card-title> -->
                            <v-card-title style="display: grid; place-items: center;"><v-icon color="blue"
                                    x-large>mdi-calendar</v-icon></v-card-title>
                            <v-card-text>
                                <div class="d-flex flex-no-wrap justify-space-between">
                                    <v-row align="center">
                                        <v-col cols="6" style="display: grid; place-items: center;">
                                            <span class="text-h5">{{ item.nombremes }}</span>
                                        </v-col>
                                        <v-col cols="6" style="display: grid; place-items: center;">
                                            <v-row align="center">
                                                <span style="font-size: 42px; color:#3364FF;">
                                                    {{ item.Conteo }}
                                                </span>
                                            </v-row>
                                            <v-row justify="center">
                                                <span>Concluidos</span>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapState } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import UtilidadesServ from '@/services/Utilidades/Utilidades.service.js';
import moment from 'moment'
import xlsxPopulate from 'xlsx-populate';

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        DataTable,
        Menu,
        xlsxPopulate,
    },
    data() {
        return {
            permisoConcluidos: false,
            showcargando: true,
            conclusion: false,
            concluidos: [],
            urlReportes: "Utilidades/ExpedientesConcluidos",
            showReportes: false,
            columnasReporte: [
                { name: 'Reporte', data: 'nrreporte', title: "Reporte", formatter: [this, "reporteForm"], },
                { name: 'Fecha Reporte', data: 'svfhreporte', title: "Fecha Reporte" },
                { name: 'Fecha Cerrado', data: 'svfhcerrado', title: "Fecha Cerrado" },
                { name: 'Cliente', data: 'clnombre', title: "Cliente" },
                { name: 'Abogado', data: 'prnombre', title: "Abogado" },
                { name: 'Estado', data: 'esnombre', title: "Estado" },
            ],
            formatterActionsReportes: [
                { click: [this, "BuscarDetalleRep"] },
            ],
            displayInputsReportes: {
                mes: 0,
                anio: 0,
            },
            nombreArchivo: '',
            listado: '',
            disabledExcel: true,
            apiDT: null,
        }
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    methods: {
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        async BuscarDetalleRep(params, item, fila) {
            let reporte = {
                nrreporte: item.nrreporte,
                svindice: item.svindice,
                aiclave: item.aiclave,
                svfhconclusion: item.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", item.nrreporte);
            formData.append("svindice", item.svindice);
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });

            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` });
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                this.$router.push({ name: `${"Asistencias"}` });
            }
        },
        reporteForm(datos) {
            if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {
                return `<div class="ml-4"><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.nrreporte}-${datos.svindice}</span></button></div>`;
            } else {
                return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
            }
        },
        async BuscarPendientes(item) {
            this.showReportes = true;
            this.displayInputsReportes = {
                mes: item.mes,
                anio: item.anio,
            },
                await this.reloadTable();
        },
        async Regresar() {
            this.showReportes = false;
            this.disabledExcel = true;
        },
        async DescargarExcel() {
            this.showcargando = true;
            let today = moment().format('yyyy-MM-DD');
            this.nombreArchivo = 'Expedientes_Concluidos_' + today.toString();
            const response = await UtilidadesServ.ExpedientesConcluidosExcel(this.displayInputsReportes.mes, this.displayInputsReportes.anio);
            await MetodosGenerales.exportToExcel(response, this.nombreArchivo, false, true);
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'Utilidades');
            formData.append("laaccion", "Descargar Archivo excel");
            formData.append("lacaracteristicas", 'Concluidos');
            formData.append("lanombre", this.nombreArchivo + ".xlsx");
            formData.append("ladestinatario", " ");
            await UtilidadesServ.AlmacenarVisitas(formData);
            this.showcargando = false;
        },
        valCargando() {
            this.disabledExcel = this.apiDT.data().length > 0 ? false : true;
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '292').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 292)//Permiso para ver concluidos
                        this.permisoConcluidos = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        this.concluidos = await UtilidadesServ.ObtenerConcluidos();
        this.showcargando = false;
    }
}
</script>

<style>
.reporteindice {
    color: var(--v-anchor-base);
}

/* @media screen and (min-height: 666px) {
    .cardConcluidos {
        height: 70vh;
    }
}
 */
/* @media screen and (max-width: 665px) {
    .cardConcluidos {
        height: 100%;
    }
} */
</style>
